import { ContentSaveEditIcon } from './ContentSaveEditIcon';

/**
 * author: Michael Irigoyen
 * id 12E2DE0D-BF3F-402D-8044-B18E269D32C2
 * name content-save-edit
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/content-save-edit.svg
 * tags
 * - Edit / Modify 
 */
export const FloppyDiscEditIcon = ContentSaveEditIcon;
export default FloppyDiscEditIcon